import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import {
    VerificationService,
    getLogoUrl,
    LogoComponent,
    PoweredByComponent,
} from '@sheerid/jslib';
import { SUCCESS_REDIRECT } from '../../constants';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const redirect = (redirectDestination: string) => {
    const win = window.open(redirectDestination, '_parent');
    win.focus();
};

const StepSuccess = ({ verificationService }: StepSuccessProps) => {
    const hasLogo = !!getLogoUrl(verificationService.programTheme);
    const verificationId = verificationService.verificationResponse.verificationId;
    const redirectDestination = `${SUCCESS_REDIRECT}${verificationId}`;

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-l-horz-center">
                    { hasLogo
                        ? <LogoComponent verificationService={verificationService} />
                        : (
                            <img
                                className="sid-l-lead-image"
                                alt="design element"
                                src="https://assets-resources.sheerid.com/common/images/2018/icons/circle-check.svg"
                            />
                        )}
                </div>
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </div>
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-md">
                <FormattedHTMLMessage
                    id="step.success.emailNotification"
                    defaultMessage={`
                    We have emailed you a copy so you can use your code now or later. Look for the email from verify@sheerid.com
                `}
                />
            </div>

            <div className="sid-submit sid-l-space-top-md">
                <button
                    type="button"
                    onClick={() => redirect(redirectDestination)}
                    className="sid-btn sid-btn--dark"
                >
                    <FormattedHTMLMessage id="step.success.redirectButtonText" defaultMessage="Use code now" />
                </button>
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <PoweredByComponent verificationService={verificationService} />
            </div>
        </div>
    );
};


export const StepSuccessComponent = StepSuccess;
